var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHobbies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "470px",
    height: "470px",
    viewBox: "0 0 470 470",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hobbies") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 470,
    height: 470,
    rx: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hobbies"
  }, /*#__PURE__*/React.createElement("g", {
    id: "realistic-cat-heads-designboom-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 470,
    height: 470,
    rx: 20
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    className: "to-fill",
    fill: "#220BAB",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 470,
    height: 470,
    rx: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-cat-sitting@140x140",
    transform: "translate(143.000000, 112.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.830538,166.938966 C172.832783,161.032412 165.477328,157.626076 157.72887,157.629817 C152.889356,157.629817 148.966155,161.543289 148.966155,166.370802 C148.966155,171.198315 152.889356,175.111788 157.72887,175.111788 C160.304115,175.138694 162.739057,176.286525 164.394893,178.25415 C166.050729,180.221776 166.762188,182.812804 166.342619,185.347482 C165.323247,189.753151 161.292872,192.802461 156.764971,192.593759 L122.67801,192.593759 C120.258253,192.593759 118.296653,190.637023 118.296653,188.223266 L118.296653,101.390316 C118.308845,99.991179 117.640661,98.6728782 116.503868,97.8532221 C115.367076,97.033566 113.902609,96.8141713 112.5746,97.2645706 C105.970339,99.5945111 99.0136072,100.774252 92.0085076,100.752224 C81.313616,100.78964 70.8001448,97.9966193 61.5405475,92.6580712 C60.4890475,92.0105703 59.2140314,91.8311389 58.0239939,92.1631911 C56.8339564,92.4952433 55.8373134,93.3085281 55.2752063,94.4062683 L40.9394045,122.989291 C16.7192602,126.651764 0,147.735021 0,175.111788 C0,186.702335 4.3813575,209.997061 24.8861106,209.997061 L156.764971,209.997061 C169.852533,210.188877 181.185337,200.971084 183.631456,188.144597 C184.918956,180.569002 182.797045,172.812218 177.830538,166.938966 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4912773,87.9344086 C115.147957,89.2071616 134.577943,71.805376 136,48.9673463 L136,4.82813226 C135.949738,3.02567896 134.931937,1.39322537 133.3429,0.566402532 C131.753862,-0.260420312 129.844756,-0.15092257 128.358933,0.852260448 L110.63445,13.6243088 C99.0265465,8.75707237 85.9734535,8.75707237 74.3655504,13.6243088 L56.6410668,0.852260448 C55.1588563,-0.162710027 53.2451046,-0.27968307 51.6521815,0.547327955 C50.0592584,1.37433898 49.0418734,3.01309444 49,4.81933608 L49,48.9673463 C50.4221382,71.7981299 69.8412229,89.1971288 92.4912773,87.9344086 Z M109.936635,39.5554374 C114.754038,39.5554374 118.659314,43.4936198 118.659314,48.351614 C118.659314,53.2096081 114.754038,57.1477905 109.936635,57.1477905 C105.119233,57.1477905 101.213956,53.2096081 101.213956,48.351614 C101.213956,43.4936198 105.119233,39.5554374 109.936635,39.5554374 Z M75.0459194,39.5554374 C79.863322,39.5554374 83.7685984,43.4936198 83.7685984,48.351614 C83.7685984,53.2096081 79.863322,57.1477905 75.0459194,57.1477905 C70.2285168,57.1477905 66.3232404,53.2096081 66.3232404,48.351614 C66.3232404,43.4936198 70.2285168,39.5554374 75.0459194,39.5554374 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Hobbies",
    fill: "#FFFFFF",
    fontFamily: "Plus Jakarta Sans",
    fontSize: 48,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 39,
    y: 68
  }, "Hobbies")), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(380.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow-right",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(19.000000, 19.000000)",
    stroke: "#6E6E6E",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6 L12,6",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "6 0 12 6 6 12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(40.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow-right",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(25.000000, 25.000000) scale(-1, 1) translate(-25.000000, -25.000000) translate(19.000000, 19.000000)",
    stroke: "#6E6E6E",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6 L12,6",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "6 0 12 6 6 12"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.3,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 251,
    cy: 425,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.3,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 282,
    cy: 425,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.3,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 220,
    cy: 425,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.75,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 189,
    cy: 425,
    r: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "Cats",
    fill: "#FFFFFF",
    fontFamily: "Plus Jakarta Sans",
    fontSize: 48,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 185,
    y: 375
  }, "Cats"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHobbies);
export default __webpack_public_path__ + "static/media/hobbies.729b21ba5f9c61afe75ebcc58654c382.svg";
export { ForwardRef as ReactComponent };